import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { DesktopView } from './desktop/CreateChildProfile.desktop';
import { MobileView } from './mobile/CreateChildProfile.mobile';
import { ChildProfilePageStep, CommonPageStep } from '../..';
import { useAppSelector } from '../../../store/hooks';
import {
  selectAppAuthentication,
  selectAppPageStep,
  setAppPageStep,
} from '../../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../../store/store';

export const CreateChildProfile = (): JSX.Element => {
  // Redux Hooks
  const pageStep = useAppSelector(selectAppPageStep);
  const authenticationData = useAppSelector(selectAppAuthentication);

  React.useEffect(() => {
    outsideComponentDispatch(setAppPageStep(ChildProfilePageStep.CREATE));
  }, []);

  return (
    <React.Fragment>
      {/* {isMobile ? <MobileView /> : <DesktopView />} */}
      {<DesktopView />}
    </React.Fragment>
  );
};
